import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesCXP() {
  const { user } = useContext(AuthContext);
  const SECCIONES = [
    { section: "Pagos y Abonos", items: [
      { label: "Abonos", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ListadoAbonosProveedores", desc: "Abonos a proveedores", enabled: !!user.pagoProveedores },
    ]},
    { section: "Consultas", items: [
      { label: "Compras", icon: "fas fa-money-check-alt", color: "#3b82f6", href: "/ListadoComprasCXP", desc: "Listado de compras", enabled: !!user.edoCtaProveedores },
      { label: "Estado Cuenta", icon: "fas fa-file-invoice-dollar", color: "#06b6d4", href: "/EstadoCuentaCXP", desc: "Estado de cuenta", enabled: !!user.edoCtaProveedores },
    ]},
  ];
  return (
    <MenuBotones titulo="CxP" descripcion="Cuentas por pagar a proveedores" icono="fas fa-file-invoice-dollar" color="#3b82f6" secciones={SECCIONES} />
  );
}

export default BotonesCXP;
